import React from 'react';
import { IonText } from '@ionic/react';
import { ExistingTag } from './useExistingCareMapTags';
import { TagChip } from './TagChip';

interface YourTagsSectionProps {
    tags: ExistingTag[];
    searchText: string;
    onTagClick: (
        tagName: string,
        source: 'suggested' | 'your_tags' | 'custom',
        totalSuggestions?: number
    ) => void;
    className?: string;
    loading?: boolean;
    totalSuggestions?: number;
}

export const YourTagsSection: React.FC<YourTagsSectionProps> = ({
    tags,
    searchText,
    onTagClick,
    className = '',
    loading = false,
    totalSuggestions = 0
}) => {
    if (tags.length === 0 && !loading) {
        return null;
    }

    return (
        <div className={`suggestion-group ${className}`}>
            <IonText color="medium" className="suggestion-title">
                <small>YOUR TAGS</small>
            </IonText>
            <div className="suggestion-chips">
                {loading && tags.length === 0 ? (
                    <IonText color="medium">
                        <small>Loading your tags...</small>
                    </IonText>
                ) : (
                    tags.map(tag => (
                        <TagChip
                            key={tag.name}
                            kind="suggested"
                            tag={tag.name}
                            onSelect={() => onTagClick(tag.name, 'your_tags', totalSuggestions)}
                            usageCount={tag.count}
                            matchedText={searchText}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
